export default __webpack_public_path__ + "static/media/footer-laoapp.724e669d.svg";